'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/list.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _tickBlack = require('../media/tick-black.svg');
var _tickBlack2 = _interopRequireDefault(_tickBlack);
var _tickWhite = require('../media/tick-white.svg');
var _tickWhite2 = _interopRequireDefault(_tickWhite);
var _tickPrimary = require('../media/tick-primary.svg');
var _tickPrimary2 = _interopRequireDefault(_tickPrimary);
var _tickSecondary = require('../media/tick-secondary.svg');
var _tickSecondary2 = _interopRequireDefault(_tickSecondary);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var icons = {
  tick: {
    black: _tickBlack2.default,
    white: _tickWhite2.default,
    primary: _tickPrimary2.default,
    secondary: _tickSecondary2.default
  }
};
var Li = (0, _glamorous2.default)('li')(function (_ref) {
  var theme = _ref.theme;
  return {
    marginBottom: theme.space_sm
  };
});
var Ul = (0, _glamorous2.default)('ul')(function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type,
    color = _ref2.color;
  return {
    listStyleType: type === 'none' ? type : undefined,
    listStyleImage: type === 'default' || type === 'none' ? undefined : 'url(' + icons[type][color] + ')',
    listStylePosition: 'inside',
    paddingLeft: 0
  };
});
var List = function (_Component) {
  _inherits(List, _Component);
  function List() {
    _classCallCheck(this, List);
    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }
  _createClass(List, [{
    key: 'renderList',
    value: function renderList() {
      var _this2 = this;
      return this.props.list.map(function (text, i) {
        return _this2.props.listItem({
          text: text,
          css: _this2.props.liCss,
          key: i
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Ul, {
        css: this.props.css,
        type: this.props.type,
        color: this.props.color,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        },
        __self: this
      }, this.renderList());
    }
  }]);
  return List;
}(_react.Component);
List.propTypes = {
  list: (0, _propTypes.arrayOf)(_propTypes.node).isRequired,
  type: (0, _propTypes.oneOf)(['tick', 'default', 'none']),
  color: (0, _propTypes.oneOf)(['primary', 'black', 'white', 'secondary']),
  listItem: _propTypes.func,
  liCss: _propTypes.object,
  css: _propTypes.object
};
List.defaultProps = {
  type: 'default',
  color: 'black',
  listItem: function listItem(_ref3) {
    var text = _ref3.text,
      css = _ref3.css,
      key = _ref3.key;
    return _react2.default.createElement(Li, {
      css: css,
      key: key,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42
      },
      __self: undefined
    }, text);
  }
};
exports.default = List;